import React, { useState } from "react";
import Header from "../Header";
import "../Header.css";
import SliderSection from "../SliderSection";
import Countdown from "../Countdown";
import RegistrationForm from "../RegistrationForm";
import GridSection from "../GridSection";
import ImageGallery from "../ImageGallery";
import Footer from "../Footer";
import ContactSection from "../ContactSection";
import ContactSectionLN from "../ContactSectionLN";
import ResultsTable from "../ResultsTable";
import Card from "../Card";

const Home = () => {
  const [showForm, setShowForm] = useState(false);

  const targetDate = "2026-11-05T00:00:00";
  // const adventureResult = "Adventure_2024";
  // const trophyResult = "Trophy_2024";

  return (
    <div>
      <Header />
      <SliderSection onRegisterClick={() => setShowForm(!showForm)} />
      {/* {showForm && <RegistrationForm />} */}
      {showForm && (
        <React.Suspense fallback={<p>Loading results...</p>}>
          <ResultsTable result="Adventure_2025" />
          <ResultsTable result="Trophy_2025" />
        </React.Suspense>
      )}
      <Countdown targetDate={targetDate} />
      <GridSection />
      <Card />
      <ImageGallery />
      {/* <ContactSection /> */}
      <ContactSectionLN />
      <Footer />
    </div>
  );
};

export default Home;
